// extracted by mini-css-extract-plugin
module.exports = {"show-phone":"a10a3f92e9--show-phone--VTlNn","phones":"a10a3f92e9--phones--KLX5s"};